import Marker from './Marker'

export default Marker



// WEBPACK FOOTER //
// ./src/legacy/containers/Graphs/components/Marker/index.js